import { zodResolver } from '@hookform/resolvers/zod'
import { EGameStatus } from '@lbs/shared-rp-types'
import { useForm } from 'react-hook-form'
import { RpGameSchema, TRpGameFormData } from './schema'

export const useRpGameForm = () => {
  return useForm<TRpGameFormData>({
    resolver: zodResolver(RpGameSchema),
    defaultValues: {
      name: 'Игра',
      status: EGameStatus.CREATED,
      dealer: '',
      player: '',
      limit: -1,
      stand: -1,
      bonus: -1,
      payout: -1,
    },
  })
}
